// extracted by mini-css-extract-plugin
export var chevronIcon = "_ay-2";
export var teamName = "_ay-1";
export var teamSwitcherButton = "_ay-0";